module.exports = __webpack_public_path__ + "assets/img/dayu_qrcode.f06afe56.png";